export default "__VITE_ASSET__Bs2UE2Ua__"